// English translation

const en = {
  "menu.staff_shift_schedule": "SHIFT SCHEDULING",
  "staff.shift_scheduling": "Shift Scheduling",
  "staff.shift_scheduling.select_date": "Select Date",
  "staff.shift_scheduling.section": "Section",
  "staff.shift_scheduling.days": "Days",
  "staff.shift_scheduling.add_employees": "Add Employees",
  "staff.shift_scheduling.start_date": "Start Date",
  "staff.shift_scheduling.end_date": "End Date",
  "staff.shift_scheduling.add": "Add",
  "staff.shift_scheduling.update": "Update",
  "staff.shift_scheduling.notes": "Notas",
  "staff.shift_scheduling.info": "Info. Turnos",
  "staff.shift.shift_date": "Date",
  "staff.shift.kinds": "Shifts",
  "staff.shift.kind": "Shift",
  "staff.shift.cancel_shift": "Cancel Shift",
  "staff.shift.form": "Shift",
  "staff.shift.employee": "Employee",
  "staff.shift.shift_kind": "Shift",
  "staff.shift.enter_timestamp": "Enter Time",
  "staff.shift.exit_timestamp": "Exit Time",
  "staff.shift.notes": "Notes",
  "staff.shift.total_time": "Total Time",
  "staff.shift.state": "State",
  "staff.shift.section": "Section",
  "staff.shift.event_category": "Event",
  "staff.shift.activity": "Activity",
  "staff.shift.is_billable": "Is Billable",
  "staff.shift.attendance": "Attendance",
  "staff.shift.permits_checklist": "Incidents",
  "staff.shift_scheduling.enter_permission": "Enter Permission",
  "staff.shift_scheduling.exit_permission": "Exit Permission",
  "staff.shift_scheduling.enter_timestamp": "Enter Timestamp",
  "staff.shift_scheduling.exit_timestamp": "Exit Timestamp",
  "company.employee": "Employee",
  "company.employee.position": "Position",
  "company.employee.party": "Employee",
  "company.employee.code": "Code",
  "staff.position": "Position",
  "staff.shift.position": "Position",
  "staff.shift.shift_amount": "Shift Amount",
  "staff_access.shift_scheduling.report.start_date": "Start Date",
  "staff_access.shift_scheduling.report.section": "Section",
  "staff_access.shift_scheduling.report": "Shift Scheduling Report",
  "staff_access.shift_scheduling_report.description": "Shift Scheduling Report",
  "staff.shift.day_to_compensate": "Day to Compensate",
  "staff.shift.schedule_het": "Scheduled HET",
  "staff.shift.het": "HET",
};

export default en;
